<template>
  <div class="layer notranslate">
    <div ref="toastInner" class="inner">
      <pre v-if="emMessage" class="emMessage">{{ emMessage }}</pre>
      <pre>{{ message }}</pre>
      <div class="btns">
        <button v-if="type === 'confirm'" type="button" class="btn btnWhite" @click="confirm(false)">{{ locale.cancel }}</button>
        <button type="button" class="btn" :class="{btnFull: type === 'alert'}" ref="confirmBtn" @click="confirm(true)">{{ locale.confirm }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'locale',
    'lang',
    'toast'
  ],
  computed: {
    id () {
      return this.toast.id
    },
    message () {
      return this.toast.message
    },
    emMessage () {
      return this.toast.emMessage
    },
    type () {
      return this.toast.type
    }
  },
  mounted () {
    this.$root.$el.append(this.$el)
    this.$nextTick(() => {
      const toastInner = this.$refs.toastInner
      const confirmBtn = this.$refs.confirmBtn
      document.body.classList.add('layerOn')
      if (toastInner) {
        toastInner.classList.add('enter')
      }
      if (confirmBtn) {
        confirmBtn.focus()
      }
    })
  },
  beforeDestroy () {
    document.body.classList.remove('layerOn')
    if (this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el)
    }
  },
  data () {
    return {
    }
  },
  methods: {
    confirm (isConfirm) {
      const id = this.id
      const otherData = this.toast.otherData
      this.$emit('confirm', { id: id, isConfirm: isConfirm, otherData })
    }
  }
}
</script>

<style lang="scss" scoped>
.layer {
  padding-bottom: 60px;
  .inner {
    min-width: 280px;
    max-width: 400px;
    height: auto;
    margin-top: -45px;
    white-space: pre-wrap;
    padding: 30px;
    border-radius: 8px;
    opacity: 0;
    &.enter {
      margin-top: 0;
      opacity: 1;
      animation-name: enter;
      animation-duration: 0.5s;
    }
  }
  .btns {
    padding-top: 30px;
    font-size: 14px;
  }
  .btn {
    padding-left: 5px;
    padding-right: 5px;
  }
  .emMessage {
    margin-bottom: 8px;
    font-size: 20px;
  }
  pre {
    white-space: pre-wrap;
  }
}
@keyframes enter {
  from {
    margin-top: -45px;
    opacity: 0;
  }
  to {
    margin-top: 0;
    opacity: 1;
  }
}
</style>
